import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const RANK_LABELS = ['1°', '2°', '3°', '4°'];

const SlideComponent = () => {
    const { t } = useTranslation();
    const [availableWines, setAvailableWines] = useState(['A', 'B', 'C', 'D']);
    const [selectedWines, setSelectedWines] = useState([]);

    const handleWineClick = (wine) => {
        if (selectedWines.length >= 4) return;
        setAvailableWines(prev => prev.filter(w => w !== wine));
        setSelectedWines(prev => [...prev, wine]);
    };

    const handleClearSelected = () => {
        setAvailableWines(prev => [...prev, ...selectedWines]);
        setSelectedWines([]);
    };

    return (
        <div className="an-slide">
            <h2 className="an-slide-title">{t('order_wine.title')}</h2>

            <div className="an-order-grid">
                <div className="an-order-col">
                    <div className="an-section-title">{t('order_wine.wines_tasted')}</div>
                    <div className="an-order-col">
                        {availableWines.map(wine => (
                            <button
                                key={wine}
                                className="ow-wine-btn"
                                onClick={() => handleWineClick(wine)}
                            >
                                {wine}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="an-order-col">
                    <div className="an-section-title">{t('order_wine.best_wine')}</div>
                    <div className="an-order-col">
                        {RANK_LABELS.map((rank, i) => (
                            <div key={rank} className={`ow-slot${selectedWines[i] ? '' : ' ow-slot-empty'}`}>
                                <span className="ow-slot-num">{rank}</span>
                                <span className="ow-slot-label">{selectedWines[i] || '—'}</span>
                            </div>
                        ))}
                    </div>
                    {selectedWines.length > 0 && (
                        <button className="an-clear-btn" onClick={handleClearSelected}>
                            {t('common.clear')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SlideComponent;
